export enum Tab {
  Project = 'In This Project',
  Global = 'Global',
  Revision = 'In This Revision',
}
